import React, { Component } from "react";
import { Jumbotron, Container } from "reactstrap";
import { Router, Route } from "react-router-dom";
import Navbarpane from "./Navbar";
import Homeinsert from "./Homeinsert";
import Servicesinsert from "./Servicesinsert";
import history from "./history";

class Mainpane extends Component {
  constructor(props) {
    super(props);
    this.handlePersonChange = this.handlePersonChange.bind(this);
    this.handlePersonSubmit = this.handlePersonSubmit.bind(this);
    this.state = {
      fname: "",
      lname: "",
      email: "",
      phone: "",
      consent: false,
      time: null
    };
  }

  handlePersonChange(name, value) {
    console.log(name, value);
    let change = {};
    change[name] = value;
    this.setState(change);
  }

  handlePersonSubmit() {
    let now = new Date();
    let utc_timestamp = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      now.getUTCHours(),
      now.getUTCMinutes(),
      now.getUTCSeconds(),
      now.getUTCMilliseconds()
    );
    this.setState({ time: [utc_timestamp] });
    history.push("/contact/services");
  }

  render() {
    return (
      <Router history={history}>
        <Jumbotron
          fluid
          className="indigo-gradient lighten-1 align-items-center mb-0 p-0"
        >
          <Navbarpane />
          <Container>
            <Route
              exact
              path="/"
              render={() => (
                <Homeinsert
                  fname={this.state.fname}
                  lname={this.state.lname}
                  email={this.state.email}
                  phone={this.state.phone}
                  onFormChange={this.handlePersonChange}
                  onFormSubmit={this.handlePersonSubmit}
                />
              )}
            />
            <Route
              exact
              path="/contact/services"
              render={() => (
                <Servicesinsert
                  fname={this.state.fname}
                  lname={this.state.lname}
                  email={this.state.email}
                  phone={this.state.phone}
                  onFormChange={this.handlePersonChange}
                  onFormSubmit={this.handlePersonSubmit}
                />
              )}
            />
          </Container>
        </Jumbotron>
      </Router>
    );
  }
}

export default Mainpane;



// WEBPACK FOOTER //
// ./src/components/Mainpane.js